module.exports = __webpack_public_path__ + "img/save.e6993325.svg";